<section class="partners-section" id="our-partners">
  <div class="atw-container">

    <div class="section-title partners-title">
      <span>
        <b>{{ 'atw.partners.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.partners.title' | transloco }}</h2>
        <p>{{ 'atw.partners.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="partners-card apply-card">

      <div class="partners-header">
        <div>
          <small>{{ 'atw.partners.badge' | transloco }}</small>
          <h3>{{ 'atw.partners.cardTitle' | transloco }}</h3>
        </div>


      </div>

      <div class="partners-loading" *ngIf="isLoading">
        {{ 'atw.partners.loading' | transloco }}
      </div>

      <div class="partners-error" *ngIf="errorMessage && !isLoading">
        {{ errorMessage }}
      </div>

      <div
        class="partners-grid"
        *ngIf="!isLoading && !errorMessage && partners.length"
      >
        <div
          class="partner-box"
          *ngFor="let company of partners; trackBy: trackByCompany"
        >
          <div class="partner-logo-wrap">
            <img
              *ngIf="getLogoUrl(company) && !company.logoFailed"
              [src]="getLogoUrl(company)"
              [alt]="getCompanyName(company)"
              loading="lazy"
              (error)="company.logoFailed = true"
            />

            <div
              class="partner-fallback"
              *ngIf="!getLogoUrl(company) || company.logoFailed"
            >
              {{ getInitials(company) }}
            </div>
          </div>

          <div class="partner-info">
            <strong>{{ getCompanyName(company) }}</strong>
            <span *ngIf="company.specialty || company.industry">
              {{ company.specialty || company.industry }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="partners-empty"
        *ngIf="!isLoading && !errorMessage && !partners.length"
      >
        {{ 'atw.partners.empty' | transloco }}
      </div>

    </div>

  </div>
</section>